module.exports = [{
      plugin: require('/home/saravanans/gatsby_sites/website/robochef-co/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/saravanans/gatsby_sites/website/robochef-co/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
